'use client';
import React from 'react';
import { QueryClient, QueryClientProvider } from 'react-query';
import { ReactQueryDevtools } from 'react-query/devtools';
import { ToastContainer } from 'react-toastify';

import { GoogleOAuthProvider } from '@react-oauth/google';

import env from '../config/env';
import { AppProvider } from '../context/AppContext';
import { AuthProvider } from '../context/AuthContext';

export default function Providers({ children }) {
  const [queryClient] = React.useState(() => new QueryClient());

  return (
    <QueryClientProvider client={queryClient}>
      <ReactQueryDevtools initialIsOpen={false} />
      <AppProvider>
        <GoogleOAuthProvider clientId={env.OAUTH.GOOGLE.CLIENT_ID}>
          <AuthProvider>
            <ToastContainer theme="dark" />
            {children}
          </AuthProvider>
        </GoogleOAuthProvider>
      </AppProvider>
    </QueryClientProvider>
  );
}
